<template>
  <div class="overflow: auto">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">奖励来源类型:</div>
        <Select v-model="productId" @on-change="changeInput" class="select">
          <Option v-for="item in ProductData" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">代理人姓名/手机号:</div>
        <Input v-model="agentKeyword" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">办理用户姓名:</div>
        <Input v-model="name" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">办理用户手机号:</div>
        <Input v-model="phone" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">办理用户身份证:</div>
        <Input v-model="idNo" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">用户产品信息名称:</div>
        <Input v-model="productName" @input="changeInput()" search class="select" />
      </div>
      <div class="search_list">
        <div class="text">按时间查询:</div>
        <DatePicker type="daterange" split-panels class="select" @on-change="queryTime"></DatePicker>
      </div>
      <div class="search_list">
        <a
          style="
            color: #fff;
            background: #1e88e5;
            border-color: #1e88e5;
            margin-left: 10px;
            margin-right: 10px;
            float: right;
            font-size: 14px;
            padding: 4px 10px;
          "
          :href="url"
        >导出</a>
      </div>
    </div>
    <Table :content="self" border stripe :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "Award",

  data() {
    return {
      modal1: false,
      total: 0,
      time: [],
      phone: "",
      url: this.url,
      name: "",
      idNo: "",
      self: this,
      state: "",
      keyword: "",
      agentKeyword: "",
      productName: "",
      pageNow: 1,
      ProductData: [
        {
          value: "1",
          label: "信用卡"
        },
        {
          value: "2",
          label: "活动补贴"
        },
        {
          value: "3",
          label: "拉新奖励"
        },
        {
          value: "4",
          label: "拉新达标奖励"
        }
        // {
        //   value: "1",
        //   label: "信用卡",
        // },
        // {
        //   value: "2",
        //   label: "贷款",
        // },
        // {
        //   value: "3",
        //   label: "优质客户进件奖励",
        // },
        // {
        //   value: "4",
        //   label: "拉新奖励",
        // },
        // {
        //   value: "5",
        //   label: "拉新达标奖励",
        // },
        // {
        //   value: "6",
        //   label: "办卡达标奖励",
        // },
        // {
        //   value: "7",
        //   label: "团队活动奖励",
        // },
      ],
      idNo: "",
      productId: "",
      Product: "",

      columns1: [
        {
          title: "奖励金额(元)",
          align: "center",
          key: "money",
          width: 150
        },
        {
          title: "奖励来源类型",
          align: "center",
          key: "type",
          width: 200
        },
        {
          title: "奖励时间",
          align: "center",
          key: "createTime",
          width: 200
        },
        {
          title: "奖励说明",
          align: "center",
          key: "content",
          width: 200
        },
        {
          title: "用户姓名",
          align: "center",
          key: "name",
          width: 200
        },
        {
          title: "用户手机号",
          align: "center",
          key: "phone",
          width: 200
        },

        {
          title: "用户身份证",
          align: "center",
          key: "idNo",
          width: 200
        },
        {
          title: "产品名称",
          align: "center",
          key: "productName",
          width: 200
        },
        {
          title: "代理人名称",
          align: "center",
          key: "userName",
          width: 200
        },
        {
          title: "获得奖励代理人名称",
          key: "userParentName",
          align: "userParentName",
          width: 200
        },
        {
          title: "渠道编码",
          align: "center",
          key: "t3rdCode",
          width: 200
        }
      ],
      data1: []
    };
  },

  activated: function() {
    this.getData("");
  },
  mounted: function() {
    this.getData("");
  },
  methods: {
    getData() {
      api
        .GgetReward({
          pageNow: this.pageNow,
          pageSize: "10",
          agentKeyword: this.agentKeyword,
          type: this.productId,
          name: this.name,
          idNo: this.idNo,
          phone: this.phone,
          start: this.time[0],
          end: this.time[1],
          productName: this.productName
        })
        .then(res => {
          if (res.body.data) {
            this.total = res.body.data.total;
            this.data1 = res.body.data.list;
            this.data1.forEach(element => {
              element.money = element.money / 100;

              if (element.type == 1) {
                element.type = "信用卡";
              } else if (element.type == 2) {
                element.type = "活动补贴";
              } else if (element.type == 3) {
                element.type = "拉新奖励";
              } else if (element.type == 4) {
                element.type = "拉新达标奖励";
              }
            });
          } else {
            this.total = [];
            this.data1 = [];
          }
        });
      let c = encodeURIComponent(this.productName);
      this.url = `/api/v1/reward/getRewardToExcel?agentKeyword=${
        this.agentKeyword ? this.agentKeyword : ""
      }&type=${this.productId ? this.productId : ""}&name=${
        this.name ? this.name : ""
      }&idNo=${this.idNo ? this.idNo : ""}&start=${
        this.time[0] ? this.time[0] : ""
      }&end=${this.time[1] ? this.time[1] : ""}&phone=${
        this.phone ? this.phone : ""
      }&productName=${c ? c : ""}`;
    },
    changeInput() {
      this.pageNow = 0;
      this.getData();
    },

    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData(this.keyword);
    }
  }
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>